import { createContext } from 'react'

/**
 * The element a nested overlay (combobox listbox, popover) should portal INTO — a Dialog provides its own
 * popup, so an overlay opened inside one stays inside it and a click on that overlay is not an outside press
 * dismissing the dialog underneath.
 * Its own tiny module so importing it from `dialog.tsx` does not pull the @base-ui Combobox chunk (≈30 KB gz)
 * into the main entry bundle.
 */
export const PortalContainerContext = createContext<HTMLElement | null>(null)
